import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
export function AdminModal({ open, title, onClose, children, footer, wide }) {
    useEffect(() => {
        if (!open)
            return undefined;
        const onKey = (event) => {
            if (event.key === 'Escape')
                onClose();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [open, onClose]);
    if (!open)
        return null;
    return (_jsx("div", { className: "admin-modal-backdrop", onClick: onClose, role: "presentation", children: _jsxs("div", { className: `admin-modal${wide ? ' admin-modal--wide' : ''}`, role: "dialog", "aria-modal": "true", "aria-labelledby": "admin-modal-title", onClick: (event) => event.stopPropagation(), children: [_jsxs("div", { className: "admin-modal-head", children: [_jsx("h2", { id: "admin-modal-title", children: title }), _jsx("button", { type: "button", className: "admin-icon-btn", onClick: onClose, "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", children: "\u00D7" })] }), _jsx("div", { className: "admin-modal-body", children: children }), footer ? _jsx("div", { className: "admin-modal-foot", children: footer }) : null] }) }));
}
